import React, {useEffect, useState} from 'react'
import {PageContainer, SearchBoxContainer} from '../../assets/styles/layout'
import RXRButton from '../RXRButton'
import Routes from '../../constants/RouteConstants'
import PageHeader from '../PageHeader'
import ClearableInput from '../ClearableInput'
import {makeStyles} from '@mui/styles'
import ListUsersTable from './ListUsersTable'
import {generatePath, useHistory, matchPath, useLocation} from 'react-router-dom'
import SidePanel from '../SidePanel'
import CreateOrEditUser from './CreateOrEditUser'
import {Grid} from '@mui/material'
import GenericFilterMenu from '../GenericFilterMenu'
import {useDispatch, useSelector} from 'react-redux'
import {selectBuildingsByActiveOrganization} from '../../reducers/selectors'
import {spaceMedium} from '../../assets/styles/spacing'
import {loadStaffAtOrganization} from '../../actions/globalAdminActions'
import LoadingStateIconAndMessage from '../LoadingStateIconAndMessage'

function UserManagement(props) {
  const classes = useStyles()
  const buildingsInOrg = useSelector(selectBuildingsByActiveOrganization)
  const staffLookup = useSelector(state => state.GlobalAdmin.staffLookup)
  const filterLabelMap = buildingsInOrg.reduce((acc, building) => {
    acc[building.id] = building.displayName
    return acc
  }, {})
  const activeOrganization = useSelector(state => state.GlobalAdmin.organizationsLookup[state.GlobalAdmin.activeOrganizationId])
  const [filterBuildings, setFilterBuildings] = useState(Object.keys(filterLabelMap))
  const [filterTerm, setFilterTerm] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const history = useHistory()
  const {pathname} = useLocation()

  const dispatch = useDispatch()

  useEffect(() => {
    if (Object.keys(staffLookup).length === 0) {
      setIsLoading(true)
      loadStaffAtOrganization(
        dispatch,
        buildingsInOrg.map(b => b.id),
      )
        .catch(err => {
          window.alert(err.message)
          console.error(err)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [staffLookup])

  const createMatch = matchPath(pathname, {path: Routes.ADMIN_DASHBOARD_USER_MANAGEMENT_CREATE})
  const isCreateMode = !!createMatch

  const viewUserMatch = isCreateMode ? null : matchPath(pathname, {path: Routes.ADMIN_DASHBOARD_USER_MANAGEMENT_VIEW_SINGLE})
  const focusedUserId = viewUserMatch ? viewUserMatch.params.userId : null

  const closeSidePanel = () => {
    history.push(Routes.ADMIN_DASHBOARD_USER_MANAGEMENT)
  }

  const handleRefresh = () => {
    closeSidePanel()
    setIsLoading(true)
    loadStaffAtOrganization(
      dispatch,
      buildingsInOrg.map(b => b.id),
    )
      .catch(err => {
        window.alert(err.message)
        console.error(err)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <div style={PageContainer}>
      <PageHeader
        title={'User management'}
        hideTrademark={true}
        rightControlComponent={
          <RXRButton
            onClick={() => {
              history.push(Routes.ADMIN_DASHBOARD_USER_MANAGEMENT_CREATE)
            }}
          >
            Add new
          </RXRButton>
        }
      >
        <Grid container spacing={3} style={{marginBottom: spaceMedium}}>
          <Grid item md={6}>
            <div className={classes.searchUsersContainer}>
              <ClearableInput value={filterTerm} onChange={setFilterTerm} placeholder={'Search users'} />
            </div>
          </Grid>
          <Grid item md={6} style={{textAlign: 'right'}}>
            <GenericFilterMenu onChange={setFilterBuildings} filterLabelMap={filterLabelMap} selectedFilters={filterBuildings}>
              <RXRButton onClick={() => {}} type={RXRButton.TYPE_TEXT}>
                FILTERS
              </RXRButton>
            </GenericFilterMenu>
          </Grid>
        </Grid>
      </PageHeader>

      <div style={{flex: 1}}>
        {isLoading ? (
          <LoadingStateIconAndMessage message={'Loading staff accounts...'} />
        ) : (
          <ListUsersTable
            filterBuildings={filterBuildings}
            filterTerm={filterTerm}
            onClickUser={staffId => history.push(generatePath(Routes.ADMIN_DASHBOARD_USER_MANAGEMENT_VIEW_SINGLE, {userId: staffId}))}
            activeOrganization={activeOrganization}
          />
        )}
      </div>

      <SidePanel
        isOpen={!!(focusedUserId || isCreateMode)}
        onClose={closeSidePanel}
        title={focusedUserId ? 'Edit dashboard user' : 'Create dashboard user'}
      >
        <CreateOrEditUser
          staffId={focusedUserId}
          onSave={handleRefresh}
          onCancel={closeSidePanel}
          onDeactivate={handleRefresh}
        />
      </SidePanel>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  searchUsersContainer: {
    ...SearchBoxContainer,
  },
}))

export default UserManagement
